/**
 * Tooltip implementation of the Popper component
 */
import React from 'react';

import { Direction, Popper } from '~shared/components/Popper/Popper';

const PopoverContent = ({ content }: { content: React.ReactNode }) => {
  return (
    <div
      style={{
        maxWidth: '370px',
        boxShadow: '0px 16px 72px 0px #00000029',
      }}
      className={'rounded-2 bg-white p-8'}
    >
      {content}
    </div>
  );
};
interface PopoverProps {
  content: React.ReactNode;
  delay?: number;
  enablePersistence?: boolean;
  children: React.ReactNode;
  disableArrow?: boolean;
  direction?: Direction;
  isDisabled?: boolean;
  mode?: 'click' | 'hover' | 'context';
}

export const Popover = ({
  content,
  delay,
  enablePersistence,
  children,
  disableArrow,
  direction,
  isDisabled,
  mode = 'hover',
}: PopoverProps) => {
  return (
    <Popper
      theme={'light'}
      mode={mode}
      isDisabled={isDisabled}
      direction={direction || 'top'}
      content={<PopoverContent content={content} />}
      enableArrow={disableArrow ? undefined : true}
      delay={delay || 200}
      enablePersistence={enablePersistence ? true : undefined}
    >
      {children}
    </Popper>
  );
};
